import { AxiosResponse } from "axios";
import http from "utilities/http-common";

const baseUrl = "/api/IdentityUser";

interface UpdateUser {
    name: string;
    userName: string;
    surName: string;
    password: string;
    email: string;
}

interface ResetUserPassword {
    id: string;
    password: string;
    token: string;
}

interface UpdateUserPassword {
    oldPassword: string;
    newPassword: string;
}

interface UpdateUserProfile {
    name: string;
    surname: string;
}

export async function sendLogin(userId: string, tenantId?: string) {
    const params = new URLSearchParams();

    if (userId) params.append("userId", userId);
    if (tenantId) params.append("tenantId", tenantId);

    return http
        .post(`${baseUrl}/send-login?userId=${userId}`)
        .then((res: AxiosResponse) => res.data);
}

export async function resetUserPassword(
    resetUserPasswordUser: ResetUserPassword,
) {
    return http
        .put(`${baseUrl}/reset-password`, resetUserPasswordUser)
        .then((res: AxiosResponse) => res.data);
}

export async function changeUserPassword(
    updateUserPassword: UpdateUserPassword,
) {
    return http
        .put(`${baseUrl}/password`, updateUserPassword)
        .then((res: AxiosResponse) => res.data);
}

export async function updateUserProfile(updateUserProfile: UpdateUserProfile) {
    return http
        .put(`${baseUrl}/profile`, updateUserProfile)
        .then((res: AxiosResponse) => res.data);
}

export async function getCompanyFromUser(): Promise<Company[]> {
    return http
        .get(`${baseUrl}/company-from-user`)
        .then((res: AxiosResponse<Company[]>) => res.data);
}

export async function deleteResponsible(
    userId: string,
    companyIds: string[],
    tenantId?: string,
): Promise<void> {
    const params = new URLSearchParams();
    companyIds.forEach((companyId) => params.append("companyIds", companyId));
    if (tenantId) params.append("tenantId", tenantId);
    return http
        .delete(`${baseUrl}/${userId}`, { params: params })
        .then((res: AxiosResponse<void>) => res.data);
}

export async function getRoles(): Promise<string[]> {
    return http
        .get(`/account/roles`)
        .then((res: AxiosResponse<string[]>) => res.data);
}
